// extracted by mini-css-extract-plugin
export default {"interestingProjects":"interesting-projects-interestingProjects-TuFFeI"};